(() => {
  if (window.__NZ_QUICK_ADD_LOADED__) return;
  window.__NZ_QUICK_ADD_LOADED__ = true;

  async function addVariant(variantId) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  async function getCart() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    return res.json();
  }

  function updateBubble(count) {
    const bubble =
      document.querySelector('[data-cart-count-bubble]') ||
      document.querySelector('.cart-count-bubble span') ||
      document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.textContent = String(count);
    const wrap = bubble.closest('.cart-count-bubble') || bubble;
    if (wrap && wrap.style) wrap.style.display = (count > 0 ? '' : 'none');
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.nz-add-btn');
    if (!btn) return;

    // CLAVE: si NO hay data-variant-id, NO bloqueamos (deja Dawn trabajar normal)
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();

    const span = btn.querySelector('span');
    const old = span ? span.textContent : (btn.textContent || '').trim();

    btn.disabled = true;
    if (span) span.textContent = 'Agregando...';

    try {
      await addVariant(id);
      const cart = await getCart();
      updateBubble(cart.item_count);

      if (span) span.textContent = 'Agregado ✓';
      setTimeout(() => { if (span) span.textContent = old || 'Agregar al carrito'; }, 900);
    } catch (err) {
      if (span) span.textContent = 'Error';
      setTimeout(() => { if (span) span.textContent = old || 'Agregar al carrito'; }, 900);
    } finally {
      btn.disabled = false;
    }
  }, true);
})();
